import { createStore, applyMiddleware, compose } from 'redux';
import createSagaMiddleware from 'redux-saga';

import { getPoiWatcher, getPoiFromWSWatcher, connectionWatcher } from './sagas';
import appReducer from './reducers/appReducer';

// create the saga middleware
const sagaMiddleware = createSagaMiddleware();

// create a redux store with our reducer above and middleware
export const appStore = createStore(appReducer, compose(applyMiddleware(sagaMiddleware)));

// run the saga
sagaMiddleware.run(connectionWatcher);
sagaMiddleware.run(getPoiWatcher);
sagaMiddleware.run(getPoiFromWSWatcher);
